import templateDefaults from '../templateDefaults';

const TGB_ASSETS_URL = process.env.TGB_ASSETS_CDN_URL;

export default {
  previewImage: '/img/modern/side-slab.png',
  title: 'Side Slab',
  templateData() {
    return {
      version: 'v1.1',
      title: 'Modern Side Slab',
      ...templateDefaults,
      elements: [
        {
          version: 'v1',
          type: 'image',
          name: 'Header image',
          editable: true,
          locked: false,
          aspectLock: true,
          mask: false,
          maskShape: 'oval',
          imageUrl: `${TGB_ASSETS_URL}/placeholders/traffic.jpg`,
          cssClasses: '',
          animation: true,
          loopAnimation: false,
          animationInStyle: 'fadeIn',
          animationInDuration: 750,
          animationInDelay: 0,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          fillType: 'stretch',
          border: false,
          borderWidth: 2,
          borderColor: '#000000',
          boxShadow: false,
          boxShadowX: 1,
          boxShadowY: 2,
          boxShadowBlur: 4,
          boxShadowSpread: 0,
          boxShadowColor: '#000000',
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          borderBottomLeftRadius: 0,
          blur: false,
          blurSize: 10,
          styles: {
            top: 139,
            left: 99,
            width: 563,
            height: 227,
            opacity: 1,
          },
        },
        {
          version: 'v1',
          type: 'text',
          editable: true,
          name: 'Bullet 1',
          locked: false,
          text: '<ul><li><strong>Bullet 1</strong></li></ul>',
          cssClasses: '',
          animation: true,
          loopAnimation: false,
          animationInStyle: 'slideInLeft',
          animationInDuration: 1000,
          animationInDelay: 1000,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          textShadow: false,
          textShadowX: 1,
          textShadowY: 2,
          textShadowBlur: 4,
          textShadowColor: '#000000',
          ticker: false,
          fillStyle: 'solid',
          backgroundColor: '#00c4dd',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          background: false,
          styles: {
            top: 501,
            left: 139,
            width: 470,
            height: 44,
            opacity: 1,
            color: 'rgb(255, 255, 255)',
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto","Helvetica Neue", Arial, sans-serif',
            textTransform: 'none',
            textDecoration: 'none',
            fontSize: 36,
            fontWeight: 'normal',
            fontStyle: 'normal',
            letterSpacing: 0,
          },
        },
        {
          version: 'v1',
          type: 'text',
          editable: true,
          name: 'Bullet 2',
          locked: false,
          text: '<ul><li><strong>Bullet 2</strong></li></ul>',
          cssClasses: '',
          animation: true,
          loopAnimation: false,
          animationInStyle: 'slideInLeft',
          animationInDuration: 1000,
          animationInDelay: 1100,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          textShadow: false,
          textShadowX: 1,
          textShadowY: 2,
          textShadowBlur: 4,
          textShadowColor: '#000000',
          ticker: false,
          fillStyle: 'solid',
          backgroundColor: '#00c4dd',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          background: false,
          styles: {
            top: 587,
            left: 139,
            width: 470,
            height: 44,
            opacity: 1,
            color: 'rgb(255, 255, 255)',
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto","Helvetica Neue", Arial, sans-serif',
            textTransform: 'none',
            textDecoration: 'none',
            fontSize: 36,
            fontWeight: 'normal',
            fontStyle: 'normal',
            letterSpacing: 0,
          },
        },
        {
          version: 'v1',
          type: 'text',
          editable: true,
          name: 'Bullet 3',
          locked: false,
          text: '<ul><li><strong>Bullet 3</strong></li></ul>',
          cssClasses: '',
          animation: true,
          loopAnimation: false,
          animationInStyle: 'slideInLeft',
          animationInDuration: 1000,
          animationInDelay: 1200,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          textShadow: false,
          textShadowX: 1,
          textShadowY: 2,
          textShadowBlur: 4,
          textShadowColor: '#000000',
          ticker: false,
          fillStyle: 'solid',
          backgroundColor: '#00c4dd',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          background: false,
          styles: {
            top: 681,
            left: 139,
            width: 470,
            height: 44,
            opacity: 1,
            color: 'rgb(255, 255, 255)',
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto","Helvetica Neue", Arial, sans-serif',
            textTransform: 'none',
            textDecoration: 'none',
            fontSize: 36,
            fontWeight: 'normal',
            fontStyle: 'normal',
          },
        },
        {
          version: 'v1',
          type: 'text',
          editable: true,
          name: 'Bullet 4',
          locked: false,
          text: '<ul><li><strong>Bullet 4</strong></li></ul>',
          cssClasses: '',
          animation: true,
          loopAnimation: false,
          animationInStyle: 'slideInLeft',
          animationInDuration: 1000,
          animationInDelay: 1300,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          textShadow: false,
          textShadowX: 1,
          textShadowY: 2,
          textShadowBlur: 4,
          textShadowColor: '#000000',
          ticker: false,
          fillStyle: 'solid',
          backgroundColor: '#00c4dd',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          background: false,
          styles: {
            top: 771,
            left: 139,
            width: 470,
            height: 44,
            opacity: 1,
            color: 'rgb(255, 255, 255)',
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto","Helvetica Neue", Arial, sans-serif',
            textTransform: 'none',
            textDecoration: 'none',
            fontSize: 36,
            fontWeight: 'normal',
            fontStyle: 'normal',
            letterSpacing: 0,
          },
        },
        {
          version: 'v1',
          type: 'text',
          editable: true,
          name: 'Headline',
          locked: false,
          text: '<p><strong>Headline</strong></p>',
          cssClasses: '',
          animation: true,
          loopAnimation: false,
          animationInStyle: 'slideInLeft',
          animationInDuration: 1000,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationInDelay: 500,
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          textShadow: false,
          textShadowX: 1,
          textShadowY: 2,
          textShadowBlur: 4,
          textShadowColor: '#000000',
          ticker: false,
          fillStyle: 'solid',
          backgroundColor: '#00c4dd',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          background: false,
          styles: {
            top: 381,
            left: 123,
            width: 524,
            height: 50,
            opacity: 1,
            color: '#000000',
            fontFamily: 'Roboto',
            textTransform: 'uppercase',
            textDecoration: 'none',
            fontSize: 48,
            fontWeight: 'normal',
            fontStyle: 'normal',
            letterSpacing: 0,
          },
        },
        {
          version: 'v1',
          type: 'rectangle',
          name: 'Headline BG',
          locked: false,
          aspectLock: false,
          cssClasses: '',
          animation: true,
          loopAnimation: false,
          animationInStyle: 'fadeIn',
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationInDuration: 750,
          animationInDelay: 0,
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          border: false,
          borderWidth: 2,
          borderColor: '#000000',
          boxShadow: false,
          boxShadowX: 1,
          boxShadowY: 2,
          boxShadowBlur: 4,
          boxShadowSpread: 0,
          boxShadowColor: '#000000',
          fillStyle: 'gradient',
          backgroundColor: '#00c4dd',
          backgroundSize: 'cover',
          gradientDirection: 0,
          gradientColorOne: 'rgb(221, 221, 221)',
          gradientColorTwo: 'rgb(255, 255, 255)',
          backgroundImage: false,
          backgroundImageUrl: '',
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          borderBottomLeftRadius: 0,
          blur: false,
          blurSize: 10,
          styles: {
            top: 365,
            left: 99,
            width: 563,
            height: 84,
            opacity: 1,
          },
        },
        {
          version: 'v1',
          type: 'rectangle',
          name: 'Upper Bar',
          locked: false,
          aspectLock: false,
          cssClasses: '',
          animation: true,
          loopAnimation: false,
          animationInStyle: 'fadeIn',
          animationInDuration: 750,
          animationInDelay: 0,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          border: false,
          borderWidth: 2,
          borderColor: '#000000',
          boxShadow: false,
          boxShadowX: 1,
          boxShadowY: 2,
          boxShadowBlur: 4,
          boxShadowSpread: 0,
          boxShadowColor: '#000000',
          fillStyle: 'solid',
          backgroundColor: 'rgb(0, 33, 76)',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          backgroundImage: false,
          backgroundImageUrl: '',
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          borderBottomLeftRadius: 0,
          blur: false,
          blurSize: 10,
          styles: {
            top: 450,
            left: 99,
            width: 563,
            height: 10,
            opacity: 1,
          },
        },
        {
          version: 'v1',
          type: 'rectangle',
          name: 'Lower Bar',
          locked: false,
          aspectLock: false,
          cssClasses: '',
          animation: true,
          loopAnimation: false,
          animationInStyle: 'fadeIn',
          animationInDuration: 750,
          animationInDelay: 0,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          border: false,
          borderWidth: 2,
          borderColor: '#000000',
          boxShadow: false,
          boxShadowX: 1,
          boxShadowY: 2,
          boxShadowBlur: 4,
          boxShadowSpread: 0,
          boxShadowColor: '#000000',
          fillStyle: 'solid',
          backgroundColor: 'rgb(0, 33, 76)',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          backgroundImage: false,
          backgroundImageUrl: '',
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          borderBottomLeftRadius: 0,
          blur: false,
          blurSize: 10,
          styles: {
            top: 916,
            left: 99,
            width: 563,
            height: 10,
            opacity: 1,
          },
        },
        {
          version: 'v1',
          type: 'rectangle',
          name: 'Blue BG',
          locked: false,
          aspectLock: false,
          cssClasses: '',
          animation: true,
          loopAnimation: false,
          animationInStyle: 'fadeIn',
          animationInDuration: 750,
          animationInDelay: 0,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          border: false,
          borderWidth: 2,
          borderColor: '#000000',
          boxShadow: false,
          boxShadowX: 1,
          boxShadowY: 2,
          boxShadowBlur: 4,
          boxShadowSpread: 0,
          boxShadowColor: '#000000',
          fillStyle: 'gradient',
          backgroundColor: '#00c4dd',
          backgroundSize: 'cover',
          gradientDirection: 45,
          gradientColorOne: 'rgb(0, 33, 76)',
          gradientColorTwo: 'rgb(4, 82, 183)',
          backgroundImage: false,
          backgroundImageUrl: '',
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          borderBottomLeftRadius: 0,
          blur: false,
          blurSize: 10,
          styles: {
            top: 449,
            left: 99,
            width: 563,
            height: 473,
            opacity: 1,
          },
        },
      ],
    };
  },
};
